import {
  CREATE_ORDER_REQUEST,
  CREATE_ORDER_SUCCESS,
  CREATE_ORDER_FAIL,
  CREATE_SALESMAN_CUSTOMER_FAIL,
  GET_SLOGAN_FAIL,
} from "../actionTypes";
import {
  ORDER_LIST_REQUEST,
  ORDER_LIST_SUCCESS,
  ORDER_LIST_FAIL,
} from "../actionTypes";
import {
  ORDER_UPDATE_REQUEST,
  ORDER_UPDATE_SUCCESS,
  ORDER_UPDATE_FAIL,
} from "../actionTypes";
import {
  QR_ACTIVATION_REQUEST,
  QR_ACTIVATION_SUCCESS,
  QR_ACTIVATION_FAIL,
} from "../actionTypes";
import {
  QR_DEACTIVATION_REQUEST,
  QR_DEACTIVATION_SUCCESS,
  QR_DEACTIVATION_FAIL,
} from "../actionTypes";
import {
  ORDER_STATS_REQUEST,
  ORDER_STATS_SUCCESS,
  ORDER_STATS_FAIL,
} from "../actionTypes";
import {
  ORDER_DOWNLOAD_REQUEST,
  ORDER_DOWNLOAD_SUCCESS,
  ORDER_DOWNLOAD_FAIL,
} from "../actionTypes";
import {
  PAYMENT_LIST_REQUEST,
  PAYMENT_LIST_SUCCESS,
  PAYMENT_LIST_FAIL,
} from "../actionTypes";
import {
  STATE_CITY_REQUEST,
  STATE_CITY_SUCCESS,
  STATE_CITY_FAIL,
} from "../actionTypes";
import {
  QRSTATUS_DATE_REQUEST,
  QRSTATUS_DATE_SUCCESS,
  QRSTATUS_DATE_FAILURE,
} from "../actionTypes";
import {
  GET_DEALER_ACCESS_REQUEST,
  GET_DEALER_ACCESS_SUCCESS,
  GET_DEALER_ACCESS_FAIL, 
  UPDATE_DEALER_ACCESS_REQUEST,
  UPDATE_DEALER_ACCESS_SUCCESS,
  UPDATE_DEALER_ACCESS_FAIL,
  CREATE_SLOGAN_REQUEST,
  CREATE_SLOGAN_SUCCESS,
  CREATE_SLOGAN_FAIL,
  GET_SLOGAN_REQUEST,
  GET_SLOGAN_SUCCESS,
  GET_BANNERS_FAIL,
   SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_SUCCESS,
  SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_FAIL,
  SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_REQUEST
} from "../actionTypes";
import { PAYMENT_REQUEST, PAYMENT_SUCCESS, PAYMENT_FAIL } from "../actionTypes";
import {
  CUSTOMER_REDEMPTION_SUMMARY_REQUEST,
  CUSTOMER_REDEMPTION_SUMMARY_SUCCESS,
  CUSTOMER_REDEMPTION_SUMMARY_FAIL,
} from "../actionTypes";
const initialState = {
  orders: [],
  paymentList: [],
  overall_totals: {},
  access_modules: [],
  slogans:[],
  redeedmedsalesmanqrcount:[],
  loading: false,
  success: false,
  payment: null,
  error: null,
  download_url: "",
};
const initialCityStatsState = {
  loading: false,
  error: null,
  data: [],
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ORDER_REQUEST:
    case ORDER_UPDATE_REQUEST:
      return { ...state, loading: true, success: false, error: null };
    case CREATE_ORDER_SUCCESS:
    case ORDER_UPDATE_SUCCESS:
      return { ...state, loading: false, success: true };
    case CREATE_ORDER_FAIL:
    case ORDER_UPDATE_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export const orderListReducer = (state = { orders: [] }, action) => {
  switch (action.type) {
    case ORDER_LIST_REQUEST:
      return { loading: true, orders: [] };
    case ORDER_LIST_SUCCESS:
      console.log("Received orders:", action.payload);
      return {
        ...state,
        loading: false,
        orders: action.payload,
        download_url: action.payload.download_url,
      };
      {
      }
    case ORDER_LIST_FAIL:
      return { loading: false, error: action.payload };
    case QR_ACTIVATION_SUCCESS:
      return {
        ...state,
        orders: state.orders.map((order) =>
          order.order_id === action.payload.order_id
            ? { ...order, is_active: true }
            : order
        ),
      };
    case QR_DEACTIVATION_SUCCESS:
      return {
        ...state,
        orders: state.orders.map((order) =>
          order.order_id === action.payload.order_id
            ? { ...order, is_active: false }
            : order
        ),
      };
    default:
      return state;
  }
};

// export const orderListReducer = (
//   state = { orders: [], loading: false, error: null },
//   action
// ) => {
//   switch (action.type) {
//     case ORDER_LIST_REQUEST:
//       return {
//         ...state,
//         loading: true,
//         error: null,
//       };

//     case ORDER_LIST_SUCCESS:
//       console.log("✅ Reducer received payload:", action.payload);

//       // Ensure payload is always an array
//       const orders = Array.isArray(action.payload)
//         ? action.payload
//         : action.payload.data || [];

//       return {
//         ...state,
//         loading: false,
//         orders: orders,
//         error: null,
//       };

//     case ORDER_LIST_FAIL:
//       console.error("❌ Reducer error:", action.payload);
//       return {
//         ...state,
//         loading: false,
//         error: action.payload,
//         orders: [],
//       };

//     case QR_ACTIVATION_SUCCESS:
//       return {
//         ...state,
//         orders: state.orders.map((order) =>
//           order.order_id === action.payload.order_id
//             ? { ...order, is_active: true }
//             : order
//         ),
//       };

//     case QR_DEACTIVATION_SUCCESS:
//       return {
//         ...state,
//         orders: state.orders.map((order) =>
//           order.order_id === action.payload.order_id
//             ? { ...order, is_active: false }
//             : order
//         ),
//       };

//     default:
//       return state;
//   }
// };
export const orderStatisticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ORDER_STATS_REQUEST:
      return { ...state, loading: true, error: null };
    case ORDER_STATS_SUCCESS:
      return {
        loading: false,
        data: action.payload.data,
        overall_totals: action.payload.overall_totals,
        error: null,
      };
    case ORDER_STATS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
export const orderDownloadReducer = (state = initialState, action) => {
  switch (action.type) {
    case ORDER_DOWNLOAD_REQUEST:
      return { loading: true, success: false, error: null };
    case ORDER_DOWNLOAD_SUCCESS:
      return { loading: false, success: true, error: null };
    case ORDER_DOWNLOAD_FAIL:
      return { loading: false, success: false, error: action.payload };
    default:
      return state;
  }
};
export const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case PAYMENT_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
        payment: action.payload, // store updated payment info here
      };

    case PAYMENT_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
// Inside your existing reducer file

export const fetchPaymentLisReducer = (state = { payments: [] }, action) => {
  switch (action.type) {
    case PAYMENT_LIST_REQUEST:
      return { loading: true, payments: [] };
    case PAYMENT_LIST_SUCCESS:
      return { loading: false, payments: action.payload };
    case PAYMENT_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
export const stateCityReducer = (state = initialCityStatsState, action) => {
  switch (action.type) {
    case STATE_CITY_REQUEST:
      return { ...state, loading: true };
    case STATE_CITY_SUCCESS:
      console.log("Reducer received:;;;;;;;", action.payload.data);
      return { ...state, loading: false, data: action.payload.data };

    case STATE_CITY_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
export const qrStatusByDateReducer = (state = initialState, action) => {
  switch (action.type) {
    case QRSTATUS_DATE_REQUEST:
      return { ...state, loading: true, error: null };

    case QRSTATUS_DATE_SUCCESS:
      return { loading: false, data: action.payload, error: null };

    case QRSTATUS_DATE_FAILURE:
      return { loading: false, data: null, error: action.payload };

    default:
      return state;
  }
};
// export const dealerAccessReducer = (
//   state = { access_modules: null, updateSuccess: false, updateLoading: false }, // ✅ null not []
//   action
// ) => {
//   switch (action.type) {
//     case GET_DEALER_ACCESS_REQUEST:
//       return { ...state, loading: true, error: null };
//     case GET_DEALER_ACCESS_SUCCESS:
//       return { ...state, loading: false, access_modules: action.payload, error: null };
//     case GET_DEALER_ACCESS_FAIL:
//       return { ...state, loading: false, access_modules: null, error: action.payload };
//     // UPDATE
//     case UPDATE_DEALER_ACCESS_REQUEST:
//       return { ...state, updateLoading: true, updateSuccess: false, updateError: null };
//     case UPDATE_DEALER_ACCESS_SUCCESS:
//       return { ...state, updateLoading: false, updateSuccess: true, updateError: null };
//     case UPDATE_DEALER_ACCESS_FAIL:
//       return { ...state, updateLoading: false, updateSuccess: false, updateError: action.payload };

//     default:
//       return state;
//   }
// };
export const dealerAccessReducer = (
  state = { access_modules: null, updateSuccess: false, updateLoading: false }, // ✅ null not []
  action
) => {
  switch (action.type) {
    case GET_DEALER_ACCESS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_DEALER_ACCESS_SUCCESS:
      
      return { ...state, loading: false, access_modules: action.payload, error: null };
    case GET_DEALER_ACCESS_FAIL:
      return { ...state, loading: false, access_modules: null, error: action.payload };
    case UPDATE_DEALER_ACCESS_REQUEST:
      return { ...state, updateLoading: true, updateSuccess: false, updateError: null };
    case UPDATE_DEALER_ACCESS_SUCCESS:
      return { ...state, updateLoading: false, updateSuccess: true, updateError: null };
    case UPDATE_DEALER_ACCESS_FAIL:
      return { ...state, updateLoading: false, updateSuccess: false, updateError: action.payload };
    default:
      return state;
  }
};
export const SloganReducer = (
  state = { slogans: [], loading: false, updateLoading: false, updateSuccess: false, error: null, updateError: null },
  action
) => {
  switch (action.type) {
    case CREATE_SLOGAN_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_SLOGAN_SUCCESS:
      return { ...state, loading: false, error: null };
    case CREATE_SLOGAN_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_SLOGAN_REQUEST:
      return { ...state, updateLoading: true, updateError: null };
    case GET_SLOGAN_SUCCESS:
      return { ...state, updateLoading: false, slogans: action.payload, updateError: null }; // ✅ save slogans
    case GET_SLOGAN_FAIL:
      return { ...state, updateLoading: false, slogans: [], updateError: action.payload };

    default:
      return state;
  }
};
export const RedeemedSalesmanQrReducer = (
  state = {
    data: [],
    overall_summary: {},
    filters: {},
    dealer: null,
    loading: false,
    updateLoading: false,
    updateSuccess: false,
    error: null,
    updateError: null,
  },
  action
) => {
  switch (action.type) {
    case SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_REQUEST:
      return { ...state, loading: true, error: null };
    case SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data || [],
        overall_summary: action.payload.overall_summary || {},
        filters: action.payload.filters || {},
        dealer: action.payload.dealer || null,
        error: null,
      };
    case SALESMAN_QR_CODE_REEDEM_REPORT_COUNT_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
export const orderQrStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case "ORDER_QR_STATUS_REQUEST":
      return { loading: true };
    case "ORDER_QR_STATUS_SUCCESS":
      return { loading: false, data: action.payload };
    case "ORDER_QR_STATUS_FAIL":
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const customerRedemptionSummaryReducer = (
  state = { data: [], total_count: 0, loading: false, error: null },
  action
) => {
  switch (action.type) {
    case CUSTOMER_REDEMPTION_SUMMARY_REQUEST:
      return { ...state, loading: true, error: null };
    case CUSTOMER_REDEMPTION_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data || [],
        total_count: action.payload.total_count || 0,
        error: null,
      };
    case CUSTOMER_REDEMPTION_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
export default orderReducer;
